@if (person.is_contractor) {
    <span class=" badge rounded-pill bg-warning text-dark">{{ 'PEOPLE.CONTRACTOR' | translate }}</span>
}@else {
    <span class="badge rounded-pill bg-primary">{{ 'PEOPLE.INTERNAL' | translate }}</span>
}
